/*=========================================================================================
  File Name: moduleUserState.js
  Description: User Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    userList: [],
    count: "",
    userStatus: [],
    blockedReason: [],
    subscriptionYn: [],
    userInfo: {
        user: {
            userId: ""
        },
        device: {
            authKey: "",
            deviceStatus: "",
            deviceUUID: "",
            lastConnectedTime: "",
            serviceStatus: "",
            usedSubscribe: "",
        },
        subscription: {
            inAppBillingStatus: "",
            lastBillingDate: "",
            storageQuota: "",
            streamingQuotaTime: "",
            subscriptionCode: "",
            useDataTrafficYn: "",
            usedStorage: "",
            usedStreamingTime: "",
            uploadTrafficQuota: "",
            uploadUsedTraffic: "",
            downloadTrafficQuota: "",
            downloadUsedTraffic: ""
        }
    },
    selectedUser: {
        device: {
            deviceStatus: "",
            deviceUUID: "",
            lastConnectedTime: "",
            promotionStartDateTime: "",
            serviceStatus: "",
            usedSubscribe: "",
            userUUID: ""
        },
        user: {
            email: "",
            name: "",
            subscriberYn: "",
            userId: "",
            userStatus: "",
            uuid: "",
        }
    },
    userlessDevices: [],
    replaceDeviceInfo: {
        deviceStatus: "",
        deviceUUID: "",
        lastConnectedTime: "",
        promotionStartDateTime: "",
        serviceStatus: "",
        usedSubscribe: "",
        userUUID: ""
    }
}